/**
 * @file:  客户提醒抽屉
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/9/4      1.0     First version
 *
 * 注意：
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent,Fragment} from "react";
import { Link } from "react-router-dom";
import VipLvLevel from "@components/Icon/vip-badge/vipLvLevel";
import {Spin,Drawer,message,Tooltip,Alert} from 'antd';
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import Lang from "@/components/Lang/Lang";
import { toFixedWithCommas} from "@utils/number-util";
import {symbolMoneyUtil,isEmpty,getIntlYYMMDD,getWeek} from '@utils/utils';
import FollowBtn from "@components/FollowUp/FollowBtn";
import AuthBtn from "@components/HoverIcon/AuthBtn";
import "./remindDrawer.less";
import {lock} from "../../../../api/common/lock";
export default class RemindDrawer extends PureComponent {
    static defaultProps = {
        labelCode: "", // 显示 类型 //10:待初步联系 30:选品 40:下单 60:成交未实现
        canOpen:false,//是否能打开抽屉
        btnName: "",//抽屉标题
    };
    constructor(props) {
        super(props);
        const labelCode =props.labelCode;
        this.state = {
            loading: false,
            columns:[
                {
                    cnTitle: '客户信息',
                    cnTitleId: 'KeHuLieBiao',
                    dataIndex: 'buyerCode',
                    width:labelCode==40?350:500,
                    render:(text, item, index) => (<Tooltip placement="bottomLeft"
                                                            title={<div className={"black89 intoBox"}>
                                                                <div className={"mb_4 flex-item"}>{Lang({id:"GenJinJiLu",default:"跟进记录"})}<div className={"ml_16 black66 flex-1"}>
                                                                    {
                                                                        !isEmpty(item.lastFollowDays)?<div className={"flex-item flex-item-ver-center"}>
                                                                            {/* {0} 天前跟进过 今天跟进过*/}
                                                                            <span>{item.lastFollowDays>0?Lang({id:"NTianQianGenJinGuo",default:`${item.lastFollowDays} 天前跟进过`,params:[item.lastFollowDays]}):Lang({id:"JinTianGenJinGuo",default:"今天跟进过"})}</span>
                                                                            {/* 下次跟进 4月22日 周一 (5天后) | 下次跟进 {0}*/}
                                                                            {item.nextFollowDays>=0&&item.nextFollowTime&&item.nextFollowTime>0?<Fragment>，
                                                                                <span className={"mr_8"} dangerouslySetInnerHTML={{__html: __getServerLanguage('XiaCiGenJinN', `${getIntlYYMMDD(item.nextFollowTime)+" "+getWeek(item.nextFollowTime)}（<span class="${item.nextFollowDays<0?'text-red':''}">${item.nextFollowDays===0?__getServerLanguage('JinTian'):__getServerLanguage('NTianHou',item.nextFollowDays)}</span>`)+"）。"}}>
                                                                </span>
                                                                            </Fragment>:null}
                                                                        </div>:"--"
                                                                    }
                                                                </div></div>
                                                                <div className={"mb_4"}>{Lang({id:"ShouJi",default:"手机"})}<span className={"ml_16 black66"}>{item.telCode?<span className={"mr_4"}>+{item.telCode}</span>:""} {item.mobile||"--"}</span></div>
                                                                <div className={"mb_4"}>{Lang({id:"GongSiLeiXing",default:"公司类型"})}<span className={"ml_16 black66"}>{item.companyType||"--"}</span></div>
                                                                <div className={"flex-item"}>{Lang({id:"JingYingLeiMu",default:"经营类目"})}<span className={"ml_16 black66 flex-1"}>{item.mainCategoryName||"--"}</span></div>
                                                            </div>}
                                                            arrow={false}
                                                            color={"#fff"}
                                                            // trigger={"click"}
                                                            overlayClassName={"remindDrwTooltips"}>
                        <div className={"hoverBox"}>
                            <div className={"flex-item-ver-center"}>
                                <Link target={"_blank"}
                                      className="color-blue3 fw_700 font-16"
                                      to={`/customer/detail?id=${item.id}`} >
                                    {item.buyerCode||'-'}
                                </Link>
                                {(item.isTargetCustomer=="1"||item.pointLevel&&item.pointLevel>0)?<span className={"spanLevel ml_4"}>
                                    {item.isTargetCustomer=="1"?<i className={"ri-verified-badge-fill mr_4"} />:null}
                                    {item.pointLevel&&item.pointLevel>0?<VipLvLevel grade={item.pointLevel} width={24} />:null}
                                </span>:null}
                                {item.isKaBuyer=="1"?<span className={"ml_4 kaLabel"}>KA</span>:null}
                            </div>
                            {item.name?<div className="fw_500 mr_12">{item.name}</div>:null}
                            {item.city?<div className="black45">{item.city}</div>:null}
                        </div>
                    </Tooltip>),
                },
                {
                    cnTitle:labelCode==10?"注册渠道": (labelCode==30?"最近加购":'最近下单') ,///10:待初步联系 30:选品 40:下单 60:成交未实现
                    cnTitleId: labelCode==10?"ZhuCeQuDao": (labelCode==30?"ZuiJinJiaGou":'ZuiJinXiaDan'),
                    dataIndex: 'poCode',
                    render:(poCode, row, index) => labelCode==10?(<>
                        <div className={"mb_4"}>{row.createTime?getIntlYYMMDD(row.createTime):"-"}</div>
                        <div>{row.channelName}</div>
                        {/*<div className="black45">{row.userName}</div>*/}
                    </>):(<>
                        {labelCode==30?<>
                            {/*{poCode?<div className={"black89"}>{poCode}</div>:null}*/}
                            {row.lastAddTime?getIntlYYMMDD(row.lastAddTime,"HH:mm"):"-"}
                        </>:<>
                            {poCode?<div className={"black89"}>{poCode}</div>:null}
                            <div className={"mb_4"}>{row.lastOrderTime?getIntlYYMMDD(row.lastOrderTime,"HH:mm"):"-"}</div>
                        </>}
                    </>)
                }
            ],
            type40Columns:[,this.typeOption()],
        }
    }
    typeOption(labelCode){
        const option = {
            cnTitle: '操作',
            cnTitleId: 'CaoZuo',
            dataIndex: 'CaoZuo',
            width: 120,
            fixed:"right",
            render: (item = {}, row) => (<div className={"flex-item"}>
                <FollowBtn row={row}
                           labelType={"1010"}//1010:新客标签 1020:成交客户标签
                           refreshPage={()=>this.refreshPage()}
                />
                {(row.invoiceFileUrl&&labelCode=="40")?<span className={"ml_8"}><AuthBtn icon={"ri-file-text-line"}
                                                                                         tips = {Lang({id:"FuKuanPingZheng",default:"付款凭证"})}
                                                                                         onClick={()=>window.open(row.invoiceFileUrl,'_blank')}/>
              </span>:null}
                {(labelCode=="10")?<span className={"ml_8"}><AuthBtn icon={"ri-verified-badge-line"} tips = {Lang({id:"WanShanZiLiao",default:"完善资料"})}
                                                                                           className={"blueIconTips"}
                                                                                           onClick={()=>this.checkLock(row.id, row.status === "out"?0:1)} />
              </span>:null}
            </div>)
        }
        return labelCode=="40"?[{
            cnTitle: '定金',
            cnTitleId: 'DingJin',
            width: 200,
            dataIndex: 'depositPrice',
            render:(depositPrice, record, index) => (<div>
                {symbolMoneyUtil(depositPrice, record.currencySymbol)}
            </div>)
        },option]:[option]
    }
    checkLock(id, type) {
        const data = {
            buyerId: id,
            expireTime: 3600,
        };
        lock(data)
            .then((response) => {
                if (response.data.success && response.data.valid) {
                    window.open(`/customer/follow?id=${id}&follow=${type}`,'about:blank');
                } else {
                    message.info(
                        Lang({
                            id: "YouYeWuYuanZhengZaiGenJin",
                            default: "有业务员正在跟进，请勿重复操作",
                        })
                    );
                }
            })
            .catch((error) => {
                message.error(error.message);
            });
    }
    /**
     * 抽屜
     * */
    showDrawer = (flag=true) => {
        if(this.props.showDrawer){ // 打开抽屉后回调
            this.props.showDrawer(flag)
        }
        this.setState({
            visible: flag,
        });
    }
    /**
     * 刷新
     *
     */
    refreshPage(){
        this.onPageTemplateTableChild.handleFetch(1,{},true)
        // if(this.props.refreshData){ // 跟进后不会影响 注册待办数据，不用刷新
        //     this.props.refreshData()
        // }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /*
    *  labelCode: "", // 显示 类型 //10:待初步联系 30:选品 40:下单 60:成交未实现
    * */
    getTips(labelCode){
        switch (labelCode) {
            case 10:
                return Lang({id:"DaiBanTiShiDaiChuBuLianXiKeHu",
                    default:'<p><b>你需要在7天内给这些客户打电话</b>，记录第一次联系的内容，并填写客户的基本信息，认证他是否为目标客户。</p>'})
            case 30:
                return Lang({id:"DaiBanTiShiKeHuXuanPin",
                    default:'<p>这些客户值得关注。<b>请进一步确认客户是否有合作意向</b>，充分了解其购买的需求，尽可能促进成交。</p>'})
            case 40:
                return Lang({id:"DaiBanTiShiXiaDan",
                    default:'<p>现在，你需要检查是否与这些客户签订了合同，并<b>通知客户在14天内支付定金。</b></p>'})
            case 60:
                return Lang({id:"DaiBanTiShiChengJiaoShiBai",
                    default:'<p>很遗憾这些订单被取消了，<b>你需要去了解取消的原因并在系统中记录它。</b></p>'})
            default:
                return ""
        }

    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    componentWillMount() {
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }
    componentWillUnmount = () => {
        this.setState = (state, callback) => {
            return;
        };
    };
    render() {
        const {className,children,btnName,canOpen=false,labelCode } = this.props;
        const {loading = false,columns=[],visible=false,} = this.state;
        return (<Fragment>
             <div className={`${canOpen?"cursor-p":""}${className?" "+className:""}`} onClick={()=>this.showDrawer(canOpen?true:false)}>{children}</div>
            <Drawer title={<div className={"flex-item-ver-center lineH_27"}>
                                <span className={"font_18 fw_500"}>{btnName}</span>
                        </div>}
                    width={1100}
                    rootClassName={"remindDrawerWrap"}
                    // maskClosable={false}
                    destroyOnClose={true}
                    onClose={()=>this.showDrawer(false)}
                    open={visible}>
                        <Spin spinning={loading}>
                            <div className={"mb_12 alertMsg"}>
                                <Alert description={<div dangerouslySetInnerHTML={{__html:this.getTips(labelCode)}} />}
                                       type="info" showIcon
                                       icon={<i className="ri-information-fill" style={{fontSize: "18px", marginTop: "10px", marginRight: "4px"}} />} />
                            </div>
                            <AutoFetchTable columns={[...columns,...this.typeOption(labelCode)]}
                                            onRef={this.onRefTabOne}
                                            precondition={{ //前置条件
                                                labelCode: labelCode,//10:带初步联系 30:选品 40:下单 60:成交未实现
                                            }}
                                            flagShowReset={false}
                                            flagShowSearchBtn={false} //http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8316
                                            fetchApi={'/service/mg/home/follow-buyer/list'}>
                            </AutoFetchTable>
                    </Spin>
            </Drawer>
        </Fragment>);
    }
}